import PropertyMap from "../properties/Map"

interface PropertyMapProps {
  latitude: string | number
  longitude: string | number
  price: number
  draggable?: boolean
}

const PropertyMapWrapper = ({ latitude, longitude, price, draggable = false }: PropertyMapProps) => {
  const lat = typeof latitude === "number" ? latitude.toString() : latitude
  const lng = typeof longitude === "number" ? longitude.toString() : longitude

  return <PropertyMap latitude={lat} longitude={lng} price={price} draggable={draggable} />
}

export default PropertyMapWrapper
